__turbopack_context__.v({
  "search_video_and_web_results": "XeRQHa_search_video_and_web_results",
  "search_video_and_web_results__count_and_sort": "XeRQHa_search_video_and_web_results__count_and_sort",
  "search_video_and_web_results__filters": "XeRQHa_search_video_and_web_results__filters",
  "search_video_and_web_results__filters_close_icon": "XeRQHa_search_video_and_web_results__filters_close_icon",
  "search_video_and_web_results__mobile_controls": "XeRQHa_search_video_and_web_results__mobile_controls",
  "search_video_and_web_results__mobile_filters_button": "XeRQHa_search_video_and_web_results__mobile_filters_button",
  "search_video_and_web_results__mobile_sort_by": "XeRQHa_search_video_and_web_results__mobile_sort_by",
  "search_video_and_web_results__result_count": "XeRQHa_search_video_and_web_results__result_count",
  "search_video_and_web_results__sort_by": "XeRQHa_search_video_and_web_results__sort_by",
  "search_video_and_web_results_wrapper": "XeRQHa_search_video_and_web_results_wrapper",
});
